import React from "react";
import { Modal } from "react-bootstrap";
import { SessionStore } from "../../../stores";
import { ConferenceInviteActions } from '../../../actions';

class Salutation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      agreeToPolicy: false,
      errorMessage: '',
      salutation: '',
      firstName: '', 
      lastName: ''
    };
  }

  componentDidMount() {
    const { firstName, lastName, salutation } = SessionStore.getSessionUser();
    this.setState({ firstName, lastName, salutation: salutation || "" });
    ConferenceInviteActions.getSalutations((response)=>{
      this.setState({salutationOptions : response.salutations})
    });
  }

  render() {
    const { errorMessage, agreeToPolicy, salutation, firstName, lastName, salutationOptions } = this.state;
    const { showSalutationPopup } = this.props;
    console.log("enter in salutation component -> ", showSalutationPopup);
    return (
      <Modal show={showSalutationPopup}>
        <Modal.Header>
          <Modal.Title>Help us to address you better</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div className="form-inline">
              <div className="form-group">
                <select 
                  className="form-control" 
                  style={{ width: 100, margin: 5 }} 
                  value={salutation}
                  onChange={(e) => this.setState({ salutation: e.target.value })}
                >
                {salutationOptions && this._makeSalutationOptions()}
                </select>
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  style={{ margin: 5 }} 
                  value={firstName}
                  placeholder="First name" 
                  onChange={e => this.setState({ firstName: e.target.value })} 
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  style={{ margin: 5 }} 
                  value={lastName} 
                  placeholder="Last name"
                  onChange={e => this.setState({ lastName: e.target.value })} 
                />
              </div>
            </div>
            <div className="checkbox">
              <label style={{ fontWeight: 'normal' }}>
                <input 
                  type="checkbox" 
                  value={agreeToPolicy}
                  onChange={() => this.setState({ agreeToPolicy: !agreeToPolicy })}
                /> I agree to the 
                <a href="https://mentorstudents.org/terms-and-conditions" target="_blank"> Terms of Use</a> and 
                <a href="https://mentorstudents.org/privacy-policy" target="_blank"> Privacy Policy.</a>
              </label>
            </div>
            <span style={{ color: 'red' }}>{errorMessage}</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <button 
              className="btn btn-primary" 
              onClick={() => this.props.submit({ firstName, lastName, salutation, agreeToPolicy })}
              disabled={!firstName || !lastName || !salutation || salutation == "" || !agreeToPolicy}
            >
              Submit
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }  
  _makeSalutationOptions = () => {
    const {  salutationOptions, salutation } = this.state;
    const {gender = ""} = this.props;

    switch (gender) {
      case "":
        return (
          salutationOptions.default.map((option, i) => {
            return (<option key={i} value={option}
              checked={salutation === option}>{option}</option>);
          }));
      case "Male":
        return (
          salutationOptions.male.map((option, i) => {
            return (<option key={i} value={option}
              checked={salutation === option}>{option}</option>);
          }));
      case "Female":
        return (
          salutationOptions.female.map((option, i) => {
            return (<option key={i} value={option}
              checked={salutation === option}>{option}</option>)
          })
        )
    }
  }
}


export default Salutation;